import Icon from 'veui/components/Icon'

Icon.register({
  'file-box': {
    paths: [
      {
        d: 'M703.38 409.72l-64-320A32 32 0 00608 64H159a32 32 0 00-31.38 25.72l-64 320a32.06 32.06 0 00.35 14.1L63 671.88A32 32 0 0095 704h577a32 32 0 0032-32V416a32.3 32.3 0 00-.62-6.28zM185.23 128h396.54L633 384H480a32 32 0 00-32 32 64 64 0 01-128 0 32 32 0 00-32-32H134zM640 640H127.12l.76-192h132.17A128 128 0 00508 448h132z'
      }
    ],
    width: '768',
    height: '768'
  }
})
